import { Time } from "./TimeHelper";

export namespace Description {
    export class Timestamp {
        static timeAgo(timestamp: number): string {
            const now = Date.now();
            const secondsPast = Math.floor((now - timestamp) / 1000);
        
            if (secondsPast < 60) {
                return secondsPast === 1 ? '1 segundo atrás'.localized() : `${secondsPast}` + `segundos atrás`.localized();
            }
        
            const minutesPast = Math.floor(secondsPast / 60);
            if (minutesPast < 60) {
                return minutesPast === 1 ? 'hace 1 minuto'.localized() : `${minutesPast}` + ` minutos atrás`.localized();
            }
        
            const hoursPast = Math.floor(minutesPast / 60);
            if (hoursPast < 24) {
                return hoursPast === 1 ? 'hace 1 hora'.localized() : `${hoursPast}` + ` horas atrás`.localized();
            }
        
            const daysPast = Math.floor(hoursPast / 24);
            if (daysPast < 30) {
                return daysPast === 1 ? '1 día atrás'.localized() : `${daysPast}` + ` días atrás`.localized();
            }
        
            const monthsPast = Math.floor(daysPast / 30);
            if (monthsPast < 12) {
                return monthsPast === 1 ? '1 mes atrás'.localized() : `${monthsPast}` + ` meses atrás`.localized();
            }
        
            const yearsPast = Math.floor(monthsPast / 12);
            return yearsPast === 1 ? '1 año atrás'.localized() : `${yearsPast}` + ` años atrás`.localized();
        }

        static timeAgoWithDate(timestamp: number, timezone: string): string {
            const now = Date.now();

            if (now - timestamp <= Time.hoursInMiliseconds(2)) {
                return this.timeAgo(timestamp);
            }

            // Format the date considering the timezone
            const date = new Date(timestamp);
            const options: Intl.DateTimeFormatOptions = {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                timeZone: timezone,
            };
        }
        
        static fullDate(timestamp: number, timezone: string, language: string='es-ES'): string {
            const date = new Date(timestamp);
            const options: Intl.DateTimeFormatOptions = {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                timeZone: timezone,
            };

            return date.toLocaleString(language, options); 
        }
    }
}